import type * as Types from '../../../../../../graphql/generated/types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetBadWordsQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GetBadWordsQueryPage = { readonly __typename?: 'RootQueryType', readonly currentUser?: { readonly __typename?: 'AccountsUser', readonly currentCompany?: { readonly __typename?: 'AccountsCompany', readonly badWords: ReadonlyArray<string> } | null } | null };


export const GetBadWordsDocument = gql`
    query GetBadWords {
  currentUser {
    currentCompany {
      badWords
    }
  }
}
    `;

/**
 * __useGetBadWordsQuery__
 *
 * To run a query within a React component, call `useGetBadWordsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBadWordsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBadWordsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetBadWordsQuery(baseOptions?: Apollo.QueryHookOptions<GetBadWordsQueryPage, GetBadWordsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBadWordsQueryPage, GetBadWordsQueryVariables>(GetBadWordsDocument, options);
      }
export function useGetBadWordsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBadWordsQueryPage, GetBadWordsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBadWordsQueryPage, GetBadWordsQueryVariables>(GetBadWordsDocument, options);
        }
export function useGetBadWordsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetBadWordsQueryPage, GetBadWordsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetBadWordsQueryPage, GetBadWordsQueryVariables>(GetBadWordsDocument, options);
        }
export type GetBadWordsQueryHookResult = ReturnType<typeof useGetBadWordsQuery>;
export type GetBadWordsLazyQueryHookResult = ReturnType<typeof useGetBadWordsLazyQuery>;
export type GetBadWordsSuspenseQueryHookResult = ReturnType<typeof useGetBadWordsSuspenseQuery>;
export type GetBadWordsQueryResult = Apollo.QueryResult<GetBadWordsQueryPage, GetBadWordsQueryVariables>;